<template>
  <div class="word-switcher">
    <span :key="words[activeIndex]">
      {{words[activeIndex] || ""}}
    </span>
  </div>
</template>

<script>
var incInterval;
export default {
  name: "WordSwitcher",
  props: {
    words: Array
  },
  data() {
    return {
      activeIndex: 0
    };
  },
  created() {
    incInterval = setInterval(this.incActiveIndex, 2000);
  },
  destroyed() {
    clearInterval(incInterval);
  },
  methods: {
    incActiveIndex() {
      if (this.activeIndex < this.words.length - 1) {
        this.activeIndex++;
      } else {
        this.activeIndex = 0;
      }
    }
  }
};
</script>

<style scoped lang="less">
.word-switcher {
  display: inline-block;
}
</style>
